import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Monitor, Server, Phone, HardDrive, Settings, FileText, Activity, Globe } from 'lucide-react';

const dienstenList = [
  {
    icon: Monitor,
    title: 'Microsoft 365',
    desc: 'Volledige Microsoft 365 implementatie, migratie en gebruikersbegeleiding.',
    link: '/diensten/microsoft365',
  },
  {
    icon: Server,
    title: 'Managed Services',
    desc: 'Volledig IT-beheer inclusief proactieve monitoring en snelle support.',
    link: '/diensten/managed-services',
  },
  {
    icon: Shield,
    title: 'Cybersecurity',
    desc: 'Proactieve beveiliging voor uw IT-omgeving: firewalls, endpoint protection en security monitoring.',
    link: '/diensten/cybersecurity',
  },
  {
    icon: Settings,
    title: 'IT-Beheer',
    desc: 'Proactief beheer van uw IT-infrastructuur, netwerken en workstations.',
    link: '/diensten/it-beheer',
  },
  {
    icon: Phone,
    title: 'Zakelijke Telefonie',
    desc: 'Moderne VoIP en Microsoft Teams telefonie voor betere communicatie.',
    link: '/diensten/telefonie',
  },
  {
    icon: FileText,
    title: 'E-facturatie',
    desc: 'Digitale facturatie conform Belgische en Europese regelgeving, inclusief Peppol.',
    link: '/diensten/e-facturatie',
  },
  {
    icon: HardDrive,
    title: 'Backup & Recovery',
    desc: 'Geautomatiseerde backup-oplossingen en disaster recovery voor uw kritieke data.',
    link: '/diensten/backups',
  },
  {
    icon: Activity,
    title: 'Monitoring',
    desc: '24/7 monitoring van systemen en infrastructuur met proactieve waarschuwingen.',
    link: '/diensten/monitoring',
  },
  {
    icon: Globe,
    title: 'Hosting',
    desc: 'Betrouwbare hosting voor websites en bedrijfsapplicaties met hoge beschikbaarheid.',
    link: '/diensten/hosting',
  },
];

export default function Diensten() {
  return (
    <div data-testid="diensten-page">
      {/* Hero */}
      <section
        className="relative pt-40 pb-28 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #16224b 0%, #233a80 58%, #f2a100 100%)' }}
        data-testid="diensten-hero"
      >
        <div className="dot-pattern absolute inset-0" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center">
          <h1 className="text-white font-bold tracking-tight mb-6" style={{ fontSize: 'clamp(2rem, 4vw, 3.25rem)', letterSpacing: '-0.03em' }}>
            Complete IT-oplossingen
          </h1>
          <p className="text-white/70 max-w-xl mx-auto text-base leading-8">
            Van cloud-infrastructuur tot cybersecurity — wij bieden alles wat uw bedrijf nodig heeft
            voor een betrouwbare en veilige IT-omgeving.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="diensten-grid">
            {dienstenList.map((d, i) => (
              <Link key={i} to={d.link} className="diensten-card group" data-testid={`dienst-card-${i}`}>
                <div className="diensten-card-top">
                  <div className="diensten-card-icon">
                    <d.icon className="w-6 h-6" />
                  </div>
                </div>
                <div className="diensten-card-body">
                  <h3 className="diensten-card-title">{d.title}</h3>
                  <p className="diensten-card-desc">{d.desc}</p>
                </div>
                <div className="diensten-card-footer">
                  <span className="diensten-card-link">
                    Meer informatie <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#f8f9fd]">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#16224b] font-bold mb-4" style={{ fontSize: 'clamp(1.5rem, 3vw, 2.25rem)' }}>
            Niet zeker welke dienst u nodig heeft?
          </h2>
          <p className="text-[#6b7184] text-base leading-8 mb-8">
            Neem vrijblijvend contact met ons op voor een gratis IT-analyse van uw bedrijf.
          </p>
          <Link to="/contact" className="btn-gradient text-base px-10 py-4">
            Gratis IT-analyse <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
}
